import { Component, OnInit } from '@angular/core';
import { CourseBundle } from 'lms-api';
import { UserCourseDataService } from 'lms-api';
import { LmsUserService } from 'lms-api';

@Component({
  selector: 'app-bundle-list',
  templateUrl: './bundle-list.component.html',
  styleUrls: ['./bundle-list.component.scss']
})
export class BundleListComponent implements OnInit {

  constructor(public ucdService: UserCourseDataService, public lmsUserService: LmsUserService) { }

  ngOnInit() {
  }

}
